import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../../../core/Icon';
var CONFIG = [{
  label: 'People',
  children: [{
    label: 'Accounts',
    icon: 'accounts',
    link: '/EOS/Sales/#sales/Accounts'
  }, {
    label: 'Contacts',
    icon: 'contact',
    link: '/EOS/Sales/#sales/Contacts'
  }, {
    label: 'Lists',
    icon: 'lists-o',
    link: '/EOS/Sales/#sales/Lists'
  }]
}, {
  label: 'Engagement',
  children: [{
    label: 'Communications',
    icon: 'communication',
    link: '/EOS/Communications/#communications/Communications'
  }, {
    label: 'Journeys',
    icon: 'journey',
    link: '/EOS/Engage/#engage/Journeys'
  }, {
    label: 'Personas',
    icon: 'persona',
    link: '/EOS/Engage/#engage/Personas'
  }]
}, {
  label: 'Design',
  children: [{
    label: 'Projects',
    icon: 'project',
    link: '/EOS/Projects/#projects/Projects'
  }, {
    label: 'Workspaces',
    icon: 'workspace',
    link: '/EOS/Workspaces'
  }]
}, {
  label: 'Organization',
  children: [{
    label: 'Analytics',
    icon: 'analytics',
    link: '/EOS/Analytics/#analytics/Analytics'
  }, {
    label: 'Developer',
    icon: 'developer',
    link: '/EOS/Developer/#developer'
  }, {
    label: 'Admin',
    icon: 'settings',
    link: '/EOS/Settings/#settings'
  }]
}, 'separator', {
  label: 'Apps',
  children: [{
    label: 'Promotions',
    icon: 'promotion',
    link: '/EOS/Promotions'
  }]
}];

var styles = function styles(theme) {
  return {
    opened: {
      whiteSpace: 'nowrap',
      position: 'absolute',
      top: theme.common.Page.NavBar.style.height,
      backgroundColor: darken(theme.common.Page.NavBar.style.backgroundColor, 0.1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      left: 0,
      right: 0,
      zIndex: 99,
      fontSize: 14,
      '& a': {
        textDecoration: 'none'
      }
    },
    overlay: {
      opacity: 0.5,
      backgroundColor: 'black',
      position: 'fixed',
      top: theme.common.Page.NavBar.style.height,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 98
    },
    separator: {
      width: 1,
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      backgroundColor: theme.common.Page.NavBar.style.backgroundColor
    },
    moduleEntry: {
      display: 'block',
      padding: '6px 12px',
      borderRadius: '2px',
      cursor: 'pointer',
      color: 'white',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'white',
        color: theme.common.Page.NavBar.style.backgroundColor
      }
    },
    moduleIcon: {
      fontSize: 14,
      textAlign: 'left',
      width: 24,
      display: 'inline-block',
      position: 'relative',
      top: 1
    },
    columnHeader: {
      padding: '6px 12px',
      fontWeight: 600,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    }
  };
};
/**
 * @extends {React.PureComponent<import('./types').NavBarModulesProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */


var NavBarModules =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavBarModules, _React$PureComponent);

  function NavBarModules() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NavBarModules);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavBarModules)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderColumn = function (column, idx) {
      if (column === 'separator') return React.createElement("div", {
        className: _this.props.classes.separator,
        key: idx
      });
      var _this$props = _this.props,
          classes = _this$props.classes,
          theme = _this$props.theme;
      return React.createElement(Grid, {
        item: true,
        key: idx
      }, React.createElement("div", {
        className: _this.props.classes.columnHeader
      }, React.createElement(Typography, {
        color: "inherit",
        style: {
          display: 'inline-block',
          fontWeight: 'inherit'
        }
      }, column.label)), React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 1
      }, column.children.map(function (moduleEntry) {
        return React.createElement(Grid, {
          item: true,
          key: moduleEntry.label
        }, React.createElement("a", {
          href: moduleEntry.link,
          className: _this.props.classes.moduleEntry
        }, React.createElement(Icon, {
          type: moduleEntry.icon,
          className: classes.moduleIcon
        }), React.createElement(Typography, {
          color: "inherit",
          style: {
            display: 'inline-block'
          }
        }, moduleEntry.label)));
      })));
    };

    return _this;
  }

  _createClass(NavBarModules, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          open = _this$props2.open,
          toggle = _this$props2.toggle,
          classes = _this$props2.classes;
      if (!open) return null;
      return React.createElement("div", null, React.createElement("div", {
        className: classes.opened
      }, React.createElement(Grid, {
        container: true,
        direction: "row"
      }, CONFIG.map(this.renderColumn))), React.createElement("div", {
        className: classes.overlay,
        onClick: toggle
      }));
    }
  }]);

  return NavBarModules;
}(React.PureComponent);

export default withStyles(styles, {
  withTheme: true,
  name: 'ECNavBarModules'
})(NavBarModules);